import React from 'react';
import { Route, RouteProps } from 'react-router';
import { connect } from 'react-redux';

import { LoginScreen } from '../login-screen/LoginScreen';
import styles from '../private-route//PrivateRoute.module.scss';
import { TopMenuBarScreenContainer } from '../../components/top-menu-bar/TopMenuBarScreenContainer';
import AuthorizedProps from './AuthorizedProps';
import PrivateRouteProps from './PrivateRouteProps';
import { SideMenuBarScreenContainer } from '../../components/side-menu-bar/SideMenuBarScreenContainer';
import { iRootState } from '../../../store/store';

export const requireAuth = (WrappedComponent: any) => {
    const Auth: React.FC<AuthorizedProps> = ({ isAuthenticated }) => {
        return isAuthenticated ? (
            <>
                <SideMenuBarScreenContainer />
                <div className={styles.container}>
                    <TopMenuBarScreenContainer />
                    <WrappedComponent />
                </div>
            </>
        ) : (
            <LoginScreen />
        );
    };

    return connect((state: iRootState, ownProps: RouteProps) => ({
        isAuthenticated: state.Identity.isLogged,
        ...ownProps,
    }))(Auth);
};

export const PrivateMenuRoute: React.FC<PrivateRouteProps> = ({ component, ...rest }) => (
    <Route component={component ? requireAuth(component) : undefined} {...rest} />
);
